import CourseModel from './course.model';

export default class PartnerModel {
  constructor(partnerInfo) {
    this._partnerId = partnerInfo.partnerId;
    this._partnerName = partnerInfo.partnerName;
    this._isEarnedAdmission = partnerInfo.isEarnedAdmission;
    this._programType = partnerInfo.programType;
    this._partnerPrice = partnerInfo.partnerPrice;
    this._partnerServiceName = partnerInfo.partnerServiceName;
    this._partnerLogo = partnerInfo.partnerLogo;
    this._verificationField = partnerInfo.verificationField;
    this._footerText = partnerInfo.footerText;
    this._status = partnerInfo.status;
    this._imageLocationSigninSignupPage = partnerInfo.imageLocationSigninSignupPage;
    this._introductionOnSigninSignUpPage = partnerInfo.introductionOnSigninSignUpPage;
    this._imageLocationWelcomePage = partnerInfo.imageLocationWelcomePage;
    this._introductionOnWelcomePage = partnerInfo.introductionOnWelcomePage;
    this._servicePhoneNumber = partnerInfo.servicePhoneNumber;
    this._partnerProgramInfo = partnerInfo.partnerProgramInfo;
    this._welcomePageTitle = partnerInfo.welcomePageTitle;
    this._welcomeHeroImageLocation = partnerInfo.welcomeHeroImageLocation;
    this._academicInterestPageTopText = partnerInfo.academicInterestPageTopText;
    this._academicInterestPageRightText = partnerInfo.academicInterestPageRightText;
    this._previousCoursesPageText = partnerInfo.previousCoursesPageText;
    this._previousCoursesPageRightPaneText = partnerInfo.previousCoursesPageRightPaneText;
    this._courseSelectionText = partnerInfo.courseSelectionText;
    this._courseSelectionRightPaneText = partnerInfo.courseSelectionRightPaneText;
    this._serviceEmail = partnerInfo.serviceEmail;
    this._courseSelectionLowerText = partnerInfo.courseSelectionLowerText;
    this._isEligibleForSignUp = partnerInfo.isEligibleForSignUp;
    this._orientation = partnerInfo.orientation ? new CourseModel(partnerInfo.orientation) : null;
    this._studentPortalAnnouncement = partnerInfo.studentPortalAnnouncement;
    this._collectDemographicInfo = partnerInfo.shouldCollectDemographicInfo;
    this._studentPortalTitle = partnerInfo.studentPortalTitle;
    this._courseEligilibityPrice = partnerInfo.courseEligibilityPrice;
    this._creditConversionPrice = partnerInfo.partnerPrice;
    this._isPathwaysAllowed = partnerInfo.isPathwaysAllowed;
    this._corporateTandCRequiredForNewLearners = partnerInfo.corpTAndCRequiredForNewLearners;
    this._referenceId = partnerInfo.reference_id;
  }

  get status() {
    return this._status;
  }

  get corpTAndCRequiredForNewLearners() {
    return this._corporateTandCRequiredForNewLearners;
  }

  get orientation() {
    if (this._orientation) this._orientation._isSelected = true;
    return this._orientation ? [this._orientation] : [];
  }

  get partnerId() {
    return this._partnerId;
  }

  get collectDemographicInfo() {
    return this._collectDemographicInfo;
  }

  get degreePageData() {
    return {
      partnerName: this._partnerName,
      servicePhoneNumber: this._servicePhoneNumber,
      academicInterestPageTopText: this._academicInterestPageTopText,
      academicInterestPageRightText: this._academicInterestPageRightText,
      partnerProgramInfo: this._partnerProgramInfo
    };
  }

  get isEarnedAdmission() {
    return this._isEarnedAdmission;
  }
  get isPathwaysAllowed() {
    return this._isPathwaysAllowed;
  }

  get basicLearnerInformation() {
    return {
      partnerName: this._partnerName,
      partnerProgramInfo: this._partnerProgramInfo
    };
  }

  get loginPageData() {
    return {
      partnerName: this._partnerName,
      introduction: this._introductionOnSigninSignUpPage,
      background: this._imageLocationSigninSignupPage,
      partnerId: this._partnerId,
      verificationField: this._verificationField.toLowerCase(),
      servicePhoneNumber: this._servicePhoneNumber,
      partnerProgramInfo: this._partnerProgramInfo
    };
  }

  get welcomePageData() {
    return {
      partnerId: this._partnerId,
      partnerName: this._partnerName,
      isEligibleForSignUp: this._isEligibleForSignUp,
      introduction: this._introductionOnWelcomePage,
      welcomeImage: this._imageLocationWelcomePage,
      isEarnedAdmission: this.isEarnedAdmission,
      partnerLogo: this._partnerLogo,
      footerText: this._footerText,
      welcomePageTitle: this._welcomePageTitle,
      welcomeHeroImageLocation: this._welcomeHeroImageLocation,
      introductionOnSigninSignUpPage: this._introductionOnSigninSignUpPage,
      serviceEmail: this._serviceEmail,
      servicePhoneNumber: this._servicePhoneNumber,
      partnerProgramInfo: this._partnerProgramInfo,
      studentPortalTitle: this._studentPortalTitle,
      courseEligibilityPrice: this._courseEligilibityPrice,
      creditConversionPrice: this._creditConversionPrice,
      orientation: this._orientation,
      referenceId: this._referenceId
    };
  }

  get courseListPageData() {
    return {
      partnerName: this._partnerName,
      isEarnedAdmission: this.isEarnedAdmission,
      servicePhoneNumber: this._servicePhoneNumber,
      previousCoursesPageText: this._previousCoursesPageText,
      previousCoursesPageRightPaneText: this._previousCoursesPageRightPaneText,
      courseSelectionRightPaneText: this._courseSelectionRightPaneText,
      courseSelectionText: this._courseSelectionText,
      courseSelectionLowerText: this._courseSelectionLowerText,
      partnerProgramInfo: this._partnerProgramInfo
    };
  }

  get dashboardPageData() {
    return {
      partnerLogo: this._partnerLogo,
      isEarnedAdmission: this.isEarnedAdmission,
      servicePhoneNumber: this._servicePhoneNumber,
      serviceEmail: this._serviceEmail,
      studentPortalAnnouncement: this._studentPortalAnnouncement
    };
  }

  get confirmationData() {
    return {
      partnerName: this._partnerName,
      servicePhoneNumber: this._servicePhoneNumber,
      partnerProgramInfo: this._partnerProgramInfo
    };
  }

  get pathwayCourseListPageData() {
    return {
      partnerName: this._partnerName,
      isEarnedAdmission: this.isEarnedAdmission
    };
  }
}
